import { render, staticRenderFns } from "./RecPointCheckDialog.vue?vue&type=template&id=57d2a11d&scoped=true"
import script from "./RecPointCheckDialog.vue?vue&type=script&lang=js"
export * from "./RecPointCheckDialog.vue?vue&type=script&lang=js"
import style0 from "./RecPointCheckDialog.vue?vue&type=style&index=0&id=57d2a11d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2a11d",
  null
  
)

export default component.exports